<template>
    <b-container>
        <h2>Category page</h2>
        <div class="my-4 balance-display">
            <b-button variant="outline-success" to="/admin/create">Create Post</b-button>
            <b-button variant="outline-info" to="/admin">To Admin Dashboard</b-button>
        </div>
        <div v-for="post in posts" :key="post.id">
            <b-link :to="'/admin/edit' + '/' + post.id"><h3>{{ post.title }}</h3></b-link>
            <div class="balance-display">
                <p><strong>{{ post.author }}</strong></p>
                <span style="fontStyle: italic">{{ moment(post.createdAt).format('MMMM Do, YYYY')}}</span>
            </div>
            <hr>
        </div>
    </b-container>
</template>

<script>
import moment from 'moment'
import { getLatestPostsByCategory } from '../../firebase/posts'
export default {
    name: 'category-page',
    props: {
        category: String
    },
    data() {
        return {
            posts: [],
            moment,
        }
    },
    created() {
        getLatestPostsByCategory(this.category)
            .then(posts => {
                this.posts = posts
            })
    }
}
</script>

<style scoped>
    .balance-display {
        display:flex;
        justify-content: space-between
    }
</style>